import { render, staticRenderFns } from "./PdpAppointmentForm.vue?vue&type=template&id=335a48f3&scoped=true&"
import script from "./PdpAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./PdpAppointmentForm.vue?vue&type=script&lang=js&"
import style0 from "./PdpAppointmentForm.vue?vue&type=style&index=0&id=335a48f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a48f3",
  null
  
)

export default component.exports